import React, { useState, useCallback, useEffect } from 'react';

/**
 * Screen Reader Live Region for accessibility announcements
 */
export const SrLive = () => {
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Auto-clear message after 3 seconds
    if (message) {
      const timer = setTimeout(() => setMessage(''), 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <div
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
      role="status"
    >
      {message}
    </div>
  );
};

/**
 * Hook to set live region messages
 */
let globalSetMessage = null;

export const useLiveMessage = () => {
  const [message, setMessage] = useState('');

  // Register global setter
  useEffect(() => {
    globalSetMessage = setMessage;
    return () => {
      globalSetMessage = null;
    };
  }, []);

  return useCallback((msg) => {
    if (globalSetMessage) {
      globalSetMessage(msg);
    }
  }, []);
};

// Export a standalone function for use outside hooks
export const setLiveMessage = (msg) => {
  if (globalSetMessage) {
    globalSetMessage(msg);
  }
};
